/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable import/no-extraneous-dependencies */
import styled from 'styled-components';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { forwardRef, useEffect, useState } from 'react';
import {
  xxsmMobile,
  minRegularScreen,
  retina,
  maxTablet,
  primaryColor,
  primaryHeadingColor,
  primaryFont,
  wMedium,
  wLight,
  greyColor1,
  whiteColor,
  errorColor,
  SecondaryColorTwo,
  wMBold,
  scrollbar,
} from 'Utils/utilsStyle';
import { useSelector } from 'react-redux';
import { selectLoading } from 'Selector/GlobalSearchContentSelector';
import classNames from 'classnames';
import ErrorInfoIcon from '../assets/img/ErrorInfoIcon.svg';

const WrapperStyle = styled.div`
  margin-top: 24px;
  .label-wrapper {
    display: flex;
    justify-content: space-between;
    .phone-edit {
      color: ${primaryColor};
      font-weight: ${wMBold};
      font-family: ${primaryFont};
      font-size: 16px;
      letter-spacing: -0.4;
      line-height: 1.25;
      cursor: pointer;
    }
  }
  .phone-input-container {
    .react-international-phone-country-selector {
      .react-international-phone-country-selector-button {
        &.react-international-phone-country-selector-button--active {
          background-color: #fff;
        }
        height: 44px;
        border-radius: 8px 0px 0px 8px;
        padding-left: 8px;
        background-color: #F9F9F9;
      }
      .react-international-phone-country-selector-dropdown {
        border-radius: 10px;
        background: #FFF;
        box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.18);
        ${scrollbar};
        padding: 10px;
        .react-international-phone-country-selector-dropdown__list-item {
          &:hover {
             .react-international-phone-country-selector-dropdown__list-item-country-name, .react-international-phone-country-selector-dropdown__list-item-dial-code {
                font-weight: ${wMedium};
                color: ${primaryHeadingColor};
             }
          }
          min-height: 38px;
          margin: 0px -10px;
          padding: 10px;
          .react-international-phone-country-selector-dropdown__list-item-country-name, .react-international-phone-country-selector-dropdown__list-item-dial-code {
            color: #7E7E7E;
            font-family: ${primaryFont};
            font-size: 12px;
            font-weight: ${wLight};
            line-height: 18px;
          }
        }
      }
    }
    .phone-input-class {
      width: 100%;
      height: 44px;
      border-radius: 0px 8px 8px 0px;
      background-color: #F9F9F9 !important;
      border: 1px solid #DADADA !important;
      color: #7E7E7E;
      font-family: ${primaryFont};
      font-size: 16px;
      font-weight: ${wMedium};
      line-height: 20px;
      letter-spacing: -0.4px;
    }
  }
  .phoneNumberInput {
    border: 1px solid #dadada;
    border-radius: 10px;
    padding: 0;
    width: 100%;
    display: flex;
    height: 42px;
    @media screen and (max-width: ${maxTablet}) {
      height: 36px;
      border-radius: 6px;
    }
    @media screen and (min-width: ${minRegularScreen}) and (${retina}) {
      height: 38px;
      border-radius: 6px;
    }
    @media screen and (max-width: ${xxsmMobile}) {
      height: 32px;
      border-radius: 4px;
    }

    &:focus-within {
      outline: none;
      box-shadow: 0 0 0 0.1rem rgb(40 167 69 / 50%);
    }
    .PhoneInputCountry {
      padding-left: 10px;
    }
    .PhoneInputInput {
      border-radius: 10px;
      padding: 8px 12px;
      width: 100%;
      display: flex;
      color: ${primaryHeadingColor};
      font-family: ${primaryFont};
      font-size: 16px;
      font-style: normal;
      font-weight: ${wLight};
      line-height: 26px;
      outline: none;
      border: none;
      height: 100%;
      @media screen and (max-width: ${maxTablet}) {
        border-radius: 8px;
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 14px;
        line-height: normal;
      }
      @media screen and (min-width: ${minRegularScreen}) and (${retina}) {
        border-radius: 8px;
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 14px;
        line-height: normal;
      }
      @media screen and (max-width: ${xxsmMobile}) {
        border-radius: 4px;
        padding-top: 8px;
        padding-bottom: 8px;
        font-size: 12px;
        line-height: normal;
      }
      &:focus,
      &:active {
        outline: none;
        border: none;
      }
      &::placeholder {
        color: ${greyColor1};
        font-family: ${primaryFont};
        font-size: 16px;
        font-style: italic;
        font-weight: ${wLight};
        line-height: 26px;
        @media screen and (max-width: ${maxTablet}) {
          font-size: 14px;
        }
        @media screen and (min-width: ${minRegularScreen}) and (${retina}) {
          font-size: 14px;
          line-height: normal;
        }
        @media screen and (max-width: ${xxsmMobile}) {
          font-size: 12px;
        }
      }
      &::-webkit-input-placeholder {
        font-family: ${primaryFont};
        color: ${greyColor1};
        font-style: italic;
      }
      &:-moz-placeholder {
        color: ${greyColor1};
        font-family: ${primaryFont};
        font-style: italic;
      }
      &::-moz-placeholder {
        font-family: ${primaryFont};
        color: ${greyColor1};
        font-style: italic;
      }
      &:-ms-input-placeholder {
        font-family: ${primaryFont};
        color: ${greyColor1};
        font-style: italic;
      }
      &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:-webkit-autofill:active {
        -webkit-text-fill-color: ${primaryHeadingColor} !important;
        background-color: transparent !important;
        -webkit-box-shadow: 0 0 0px 1000px ${whiteColor} inset;

        &::selection {
          -webkit-text-fill-color: ${whiteColor} !important;
        }
      }
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
  }
  .errorWrapper {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 6px;

    @media screen and (max-width: ${maxTablet}) {
      gap: 4px;
      margin-top: 2px;
    }
    @media screen and (min-width: ${minRegularScreen}) and (${retina}) {
      gap: 4px;
      margin-top: 4px;
    }
    .errorInfoIcon {
      @media screen and (min-width: ${minRegularScreen}) and (${retina}) {
        height: 10px;
      }
      @media screen and (max-width: ${maxTablet}) {
        height: 10px;
      }
    }
    .errorMessage {
      color: ${errorColor};
      font-family: ${primaryFont};
      font-size: 14px;
      font-style: normal;
      font-weight: ${wMedium};
      line-height: 1;
      letter-spacing: -0.5px;

      @media screen and (max-width: ${maxTablet}) {
        font-size: 12px;
      }
      @media screen and (min-width: ${minRegularScreen}) and (${retina}) {
        font-size: 12px;
      }

      &::selection {
        background-color: transparent;
        color: currentColor;
      }
    }
  }
`;

const Label = styled.label`
  color: ${SecondaryColorTwo};
  font-family: ${primaryFont};
  font-size: 16px;
  font-style: normal;
  font-weight: ${wMedium};
  line-height: normal;
  margin-bottom: 8px;
  cursor: text;
  width: max-content;
  @media screen and (max-width: ${maxTablet}) {
    font-size: 14px;
  }
  @media screen and (max-width: ${xxsmMobile}) {
    font-size: 12px;
    margin-bottom: 6px;
  }
`;

type Props = {
  label?: string;
  id?: string;
  inputValue: string;
  isDisabled: boolean;
  onChange: (val: string) => void;
  onPhoneNumberEdit: () => void;
  isValid?: boolean
  activePhoneNumber?: boolean
  setIsValid: (value: boolean) => void
} & typeof defaultProps;

const defaultProps = {
  label: '',
  id: '',
  isValid: false,
  activePhoneNumber: false,
};
const phoneUtil = PhoneNumberUtil.getInstance();
const isPhoneValid = (phone: string) => {
  try {
    return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
  } catch (error) {
    return false;
  }
};
const PhoneNumberInput = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    inputValue,
    label,
    id,
    onChange,
    onPhoneNumberEdit,
    isDisabled,
    isValid,
    setIsValid,
    activePhoneNumber,
  } = props;
  const [errorMsg, setErrorMsg] = useState<string>('');
  const loading = useSelector(selectLoading);
  const isValidNumber = () => {
    if (!inputValue || inputValue.trim() === '' || inputValue.trim() === undefined) {
      setErrorMsg('Phone number required');
      setIsValid(false);
      return false;
    }
    if (!isPhoneValid(inputValue)) {
      setErrorMsg('Please Enter a valid number');
      setIsValid(false);
      return false;
    }
    setErrorMsg('');
    setIsValid(true);
    return true;
  };
  useEffect(() => {
    isValidNumber();
  }, [inputValue]);

  return (
    <WrapperStyle ref={ref}>
      <div className="label-wrapper">
        {label && <Label htmlFor={id}>{label}</Label>}
        <span aria-hidden="true" className="phone-edit" onClick={onPhoneNumberEdit}>
          {isDisabled ? 'Edit' : 'Cancel'}
        </span>
      </div>
      <PhoneInput
        disabled={isDisabled}
        placeholder="555 555 1212"
        value={inputValue}
        onChange={(value1: string | undefined) => {
          onChange(value1 as string);
        }}
        className="phone-input-container"
        inputClassName="phone-input-class"
      />
      {(!isValid && errorMsg && !loading && !isDisabled) && (
        <div className="errorWrapper">
          <img className="errorInfoIcon" src={ErrorInfoIcon} alt="info Icon" />
          <span className="errorMessage">{errorMsg}</span>
        </div>
      )}
      {/* {!isNumberValid && <small className="text-danger">Invalid phone number!</small>} */}
    </WrapperStyle>
  );
});

PhoneNumberInput.defaultProps = defaultProps;
export default PhoneNumberInput;
